import type { RouteObject } from "react-router";
import MeditationLibraryPage from "./ui/pages/MeditationLibraryPage";

export const publicMeditationRoutes: RouteObject[] = [
    { path: "/meditaciones", element: <MeditationLibraryPage /> },
];
